import { render, staticRenderFns } from "./PresentationsAEAT.vue?vue&type=template&id=4972d6cb&"
import script from "./PresentationsAEAT.vue?vue&type=script&lang=js&"
export * from "./PresentationsAEAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports